import { $ } from "../lib/format";
import { BORDER, CARD, DIM } from "../theme";

// ─── CHART TOOLTIP ────────────────────────────────────────────────────────────

const ChartTip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div style={{ background:CARD,border:`1px solid ${BORDER}`,borderRadius:5,padding:"10px 14px",fontFamily:"'DM Mono',monospace",fontSize:11,boxShadow:"0 4px 12px rgba(44,36,22,0.12)" }}>
      <div style={{ color:DIM,marginBottom:6,fontFamily:"'DM Sans',sans-serif",fontSize:10,letterSpacing:"0.06em",textTransform:"uppercase" }}>{label}</div>
      {payload.map((p,i) => <div key={i} style={{ color:p.color,marginBottom:3 }}>{p.name}: {$(p.value)}</div>)}
    </div>
  );
};

export { ChartTip };
